import { moduleHost } from '../../../infrastructure/components/root-module-host';
import { connectedManageAttributesVM, ManageAttributesContext } from './manage-attributes.context';
import { ManageAttributesPresentation, ManageAttributesPresentationProps } from './manage-attributes.presentation';
import { ManageAttributesVM } from './manage-attributes.viewmodel';


const ManageAttributesContainer = connectedManageAttributesVM<ManageAttributesPresentationProps>(ManageAttributesPresentation, vm => ({ vm: vm }));

export const ManageAttributes = moduleHost(ManageAttributesVM, ManageAttributesContext, ManageAttributesContainer);
